"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_c("html", [_c("head"), _c("body", [_c("h1", [_vm._v("vue-common-table")]), _c("p", [_vm._v("基于 elementUI 封装的 table 组件，支持所有 elementUI table 组件配置项 "), _c("a", {
    attrs: {
      href: "https://element.eleme.cn/2.12/#/zh-CN/component/table"
    }
  }, [_vm._v("文档")]), _vm._v("，另外多选功能做了跨分页多选")]), _c("h3", [_vm._v("Attributes")]), _c("table", [_c("thead", [_c("tr", [_c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("参数")]), _c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("类型")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("默认值")])])]), _c("tbody", [_c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("data")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("表格数据")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Array")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("-")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("columns")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("列配置,详情见下方 Column 属性")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Array")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("-")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("loading")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("加载状态")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Boolean")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("false")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("config")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("表格配置项，详情见下方 Config 属性")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Object")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("-")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("page")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("分页参数,包括:size,total,currentPage,不传时不显示分页器")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Object")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("null")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("pageConfig")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("分页器配置项，详情见下方 PageConfig 属性")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Object")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("-")])])])]), _c("h3", [_vm._v("Column Attributes")]), _c("p", [_vm._v("除此之外支持所有 el-table-column attributes")]), _c("table", [_c("thead", [_c("tr", [_c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("参数")]), _c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("类型")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("默认值")])])]), _c("tbody", [_c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("slot")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("开启 slot 支持，用于自定义列")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Boolean")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("false")])])])]), _c("h3", [_vm._v("Config Attributes")]), _c("p", [_vm._v("除此之外支持所有 el-table attributes")]), _c("table", [_c("thead", [_c("tr", [_c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("参数")]), _c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("类型")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("默认值")])])]), _c("tbody", [_c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("enableMultiSelect")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否支持多选")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Boolean")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("false")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("showHandler")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否显示操作列")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Boolean")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("false")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("handlerColumn")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("操作列配置，showHandler 为 true 时有效")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Objext")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("{label: '操作',minWidth: 100,fixed: 'right'}")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("highlightSelect")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否高亮选中行，仅多选时有效")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Boolean")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("true")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("showIndexColumn")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否显示序号列")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Boolean")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("false")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("rowKey")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("行数据的 Key，用来优化 Table 的渲染；在使用 多选 功能与显示树形数据时，该属性是必填的。类型为 String 时，支持多层访问：user.info.id，但不支持 user.info[0].id，此种情况请使用 Function。")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Function(row)/String")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("--")])])])]), _c("h3", [_vm._v("PageConfig Attributes")]), _c("p", [_vm._v("除此之外支持所有 el-pagination attributes")]), _c("table", [_c("thead", [_c("tr", [_c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("参数")]), _c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("类型")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("默认值")])])]), _c("tbody", [_c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("customClassName")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自定义分页器 className")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("String")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("-")])])])]), _c("h3", [_vm._v("Slot")]), _c("table", [_c("thead", [_c("tr", [_c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("name")]), _c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("参数")])])]), _c("tbody", [_c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("列的 prop 值")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自定义列的内容,当列的 slot 属性设置为 true 时有效")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("{ row, column, $index }")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("列的 prop 值 + '-header'")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自定义表头的内容,当列的 slot 属性设置为 true 时有效")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("{ column, $index }")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("handler")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自定义操作栏的内容")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("{ row, column, $index }")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("multiSelectMenu")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自定义多选操作列内容，enableMultiSelect 为 true 时有效，勾选行时显示")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("{ selection }")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("topMenu")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("自定义顶部操作，勾选行时不显示")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("-")])])])]), _c("h3", [_vm._v("Events")]), _c("p", [_vm._v("除此之外支持所有 el-table events")]), _c("p", [_vm._v("注： 因为添加了跨分页多选的功能，selection-change 会在切换分页设置勾选状态时调用多次")]), _c("table", [_c("thead", [_c("tr", [_c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("事件名称")]), _c("th", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _c("th", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("参数")])])]), _c("tbody", [_c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("current-page-change")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("currentPage 改变时会触发")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("当前页")])]), _c("tr", [_c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("page-size-change")]), _c("td", {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("pageSize 改变时会触发")]), _c("td", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("每页条数")])])])]), _c("h3", [_vm._v("Methods")]), _c("p", [_vm._v("支持所有 el-table 的 methods")])])])]);
}];
render._withStripped = true;